import { post } from "@/services/axiosUitils";

const baseUrl = "/nps/digilocker-token/";

class DigilockerCallbackService {
  digilockerCallback = async (code: string): Promise<any> => {
    const response = await post<any>(`${baseUrl}?code=${code}`);
    return response;
  };
}

const instance = new DigilockerCallbackService();
export default instance;
